import getClosest from '../get-closest/get-closest';
export interface DelegateEvent {
  originalEvent: Event;
  delegateTarget: HTMLElement;
}
type CallbackFunction = (e: DelegateEvent) => void;
/**
 * Delegate Event Listener.
 *
 * 1. Finds the closest element to the event target that matches the target selector.
 * 2. If the target selector matches, the event target is returned.
 * 3. If not, null is returned.
 * 4. A DelegateEvent is created, with the original event, and the delegate target.
 * 5. The callback function is called with the new event.
 */
export default function (
  container: HTMLElement | Document,
  event: string,
  target: string,
  callback: CallbackFunction,
  eventOptions: boolean | AddEventListenerOptions = undefined
) {
  container.addEventListener(
    event,
    (e) => {
      if (!(e.target instanceof HTMLElement)) return;
      let delegateTarget: HTMLElement = (e.target as HTMLElement).matches(target)
        ? e.target
        : getClosest(e.target, target);
      if (delegateTarget === null) return;
      let newEvent: DelegateEvent = { originalEvent: e, delegateTarget: delegateTarget };
      callback(newEvent);
    },
    eventOptions
  );
}
